import { Drawer } from "@blueprintjs/core";
import { type ItemCreateDrawerProps } from "@package/ui-apollo-components";
import { ProfileEdit } from "./ProfileEdit";

export function ProfileCreateDrawer({
  isOpen,
  onCreated,
  onClose,
}: ItemCreateDrawerProps) {
  return (
    <Drawer isOpen={isOpen} className="bg-slate-100 overflow-auto px-4 pb-4">
      <ProfileEdit
        toolbarProps={{
          onCanceled: onClose,
          onDeleted: () => {},
          onCreated: (id) => {
            onCreated(id);
            onClose();
          },
        }}
      />
    </Drawer>
  );
}
